<template>
    <!-- 诗词列表 -->
    <div class="poem-list">
        <!-- 标题 -->
        <div class="poem-list-title">
            <i class="iconfont iconremen"></i>
            热门推荐
        </div>
        <PoemListItem v-for="poem in poems" :key="poem.id" :poem="poem"/>
    </div>
</template>

<script>
    import PoemListItem from '@/components/PoemListItem.vue'

    export default {
        name: "PoemList",
        props:['poems'],
        components:{
            PoemListItem,
        }
    }
</script>

<style scoped lang="less">
    .poem-list{
        width: 60%;
        margin: 25px auto;
        .poem-list-title{
            font-size: 22px;
            font-weight: bold;
            margin: 25px auto;
            .iconfont{
                font-size: 22px;
                color:#fa3534;
            }
        }
    }
</style>